var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("aside", { staticClass: "perks-widget__cats" }, [
    _c("h2", [_vm._v("Categories")]),
    _vm._v(" "),
    _c(
      "ul",
      _vm._l(_vm.categories, function (parentCategory) {
        return _c("li", { key: parentCategory.category_id }, [
          _c(
            "a",
            {
              attrs: { href: "#" },
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.showOffers(parentCategory)
                },
              },
            },
            [
              _vm._v(
                "\n                " +
                  _vm._s(parentCategory.main_cat) +
                  "\n            "
              ),
            ]
          ),
          _vm._v(" "),
          parentCategory.children && parentCategory.children.length
            ? _c(
                "ul",
                _vm._l(parentCategory.children, function (childCategory) {
                  return _c("li", { key: childCategory.category_id }, [
                    _c(
                      "a",
                      {
                        attrs: { href: "#" },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.showOffers(childCategory)
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n                        " +
                            _vm._s(childCategory.sub_cat) +
                            "\n                    "
                        ),
                      ]
                    ),
                  ])
                }),
                0
              )
            : _vm._e(),
        ])
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }